import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import {
  Container,
  Box,
  Button,
  Typography,
  Grid,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Snackbar,
} from "@mui/material";
import Step1 from "./step1/step1";
import Step2 from "./step2/step2";
import Step3 from "./step3/step3";
import Step4 from "./step4/step4";
import Step5 from "./step5/step5";
import Step6 from "./step6/step6";
import Step7 from "./step7/step7";
import Step8 from "./step8/step8";
import logo from "../../logoCC.png";
import logoSm from "../../logo.png";
import ClaimNumber from "./claimNumber";
import Spinner from "../../utils/Spinner";

const StepsPage = () => {
    const {
      register,
      handleSubmit,
      control,
      formState: { errors },
      reset,
    } = useForm({
      mode: "onChange",
      defaultValues: {
        tipoInmueble: "Vivienda",
      },
    });
    const [signaturePad, setSignaturePad] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [uploadedBienesFiles, setUploadedBienesFiles] = useState([]);
    const [uploadedDamageFiles, setUploadedDamageFiles] = useState([]);
    const [uploadedAditionalFiles, setUploadedAditionalFiles] = useState([]);
    const [uploadedPymeFiles, setUploadedPymeFiles] = useState([]);
    const [data, setData] = useState([]);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [openAlertError, setOpenAlertError] = React.useState(false);
    const [nSiniestro, setNSiniestro] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const siniestro = urlParams.get("siniestro");
      if (siniestro) {
        setNSiniestro(siniestro);
      }
      setIsLoading(false);
    }, []);

    // const apiBaseUrl = "http://localhost:4000";
    // const apiBaseUrl = "https://siniestros-backend-vmly.onrender.com";
    const apiBaseUrl = "https://siniestros-backend-app.onrender.com";
  
    const handleClose = () => {
      setOpenAlert(false);
      setOpenAlertError(false);
    };
  
    const steps = [
      "Datos del propietario o representante",
      "Ubicación del riesgo",
      "Características del lugar afectado",
      "Listado de bienes afectados",
      "Daños en la edificación",
      "Pérdida o gasto adicional",
      "Documentación adicional",
      "Declaración Responsable",
    ];
  
    const calculateTotalFileSize = () => {
      const totalFiles = [
        ...uploadedBienesFiles,
        ...uploadedDamageFiles,
        ...uploadedAditionalFiles,
        ...uploadedPymeFiles,
      ];
      return totalFiles.reduce((total, file) => total + file.size, 0);
    };
  
    const fetchForm = async () => {
      if (calculateTotalFileSize > 24 * 1024 * 1024) {
        alert(
          "El tamaño total de los archivos excede el límite de 24 MB. Por favor, elimine algunos archivos."
        );
        return;
      }
  
      setIsLoading(true);
      const signature = signaturePad.toDataURL();
      const formData = new FormData();
  
      const formValues = { ...data, nSiniestro };

      Object.entries(formValues).forEach(([key, value]) => {
        if (key !== "files" && value !== undefined && value !== null) {
          formData.append(key, String(value));
        }
      });
  
      uploadedBienesFiles.forEach((file) => formData.append("bienesFiles", file));
      uploadedDamageFiles.forEach((file) => formData.append("damageFiles", file));
      uploadedAditionalFiles.forEach((file) =>
        formData.append("aditionalFiles", file)
      );
      uploadedPymeFiles.forEach((file) => formData.append("pymeFiles", file));
  
      formData.append("signature", signature);

      try {
        await axios.post(`${apiBaseUrl}/upload`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setOpenAlert(true);
        reset(); 
        setUploadedBienesFiles([]);
        setUploadedDamageFiles([]);
        setUploadedAditionalFiles([]);
        setUploadedPymeFiles([]);
        setNSiniestro("");
        signaturePad.clear(); 
        setActiveStep(0); 
      } catch (err) {
        console.error(err);
        setOpenAlertError(true);
      } finally {
        setIsLoading(false);
      }
    };
  
    const onSubmit = async (data) => {
      setData(data);
      fetchForm();
    };
  
/*     const Handsshake = async () => {
      axios.defaults.baseURL = apiBaseUrl;
      try {
        await axios.get("/status");
      } catch {
        console.error("status backend ko");
      }
    }; */
    const handleNext = (data) => {
      // Handsshake();
      setActiveStep((prev) => prev + 1);
    };
  
    const prevStep = () => {
      activeStep === 0
        ? setNSiniestro("")
        : setActiveStep((prev) => prev - 1)
    };
  
    return (
      <>
        {isLoading && <Spinner/>}
        {nSiniestro === "" ? (
          <ClaimNumber setNSiniestro={setNSiniestro} setIsAdmin={setIsAdmin}/>
        ) : (
          <Container maxWidth="md" sx={{ mt: 2 }}>
            <Paper elevation={3} sx={{ p: 4, position: "relative" }}>
              <Typography
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  padding: "5px 10px",
                  fontSize: "12px"
                }}
              >
                Siniestro nº {nSiniestro}
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <img src={logoSm} alt="logoSm" width={60} style={{marginBottom: "10px"}} />
                <Typography gutterBottom style={{ fontSize: "15px" }}>
                  Rellene el siguiente formulario:
                </Typography>
              </div>
              <Box
                sx={{
                  overflowX: "auto",
                  width: "100%",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#90caf9 #e0e0e0",
                  "&::-webkit-scrollbar": {
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#90caf9",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#42a5f5",
                  },
                }}
              >
                <Stepper activeStep={activeStep} alternativeLabel>
                  {steps.map((label, index) => (
                    <Step key={index}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
              <form onSubmit={handleSubmit(onSubmit)}>
                {activeStep === 0 && <Step1 register={register} errors={errors} />}
                {activeStep === 1 && <Step2 register={register} errors={errors} />}
                {activeStep === 2 && (
                  <Step3 register={register} errors={errors} control={control} />
                )}
                {activeStep === 3 && (
                  <Step4
                    register={register}
                    errors={errors}
                    calculateTotalFileSize={calculateTotalFileSize}
                    setUploadedBienesFiles={setUploadedBienesFiles}
                    uploadedBienesFiles={uploadedBienesFiles}
                  />
                )}
      
                {activeStep === 4 && (
                  <Step5
                    register={register}
                    errors={errors}
                    calculateTotalFileSize={calculateTotalFileSize}
                    setUploadedAditionalFiles={setUploadedAditionalFiles}
                    uploadedAditionalFiles={uploadedAditionalFiles}
                  />
                )}
                {activeStep === 5 && (
                  <Step6
                    register={register}
                    errors={errors}
                    setUploadedPymeFiles={setUploadedPymeFiles}
                    uploadedPymeFiles={uploadedPymeFiles}
                  />
                )}
                {activeStep === 6 && (
                  <Step7
                    register={register}
                    errors={errors}
                    calculateTotalFileSize={calculateTotalFileSize}
                    setUploadedDamageFiles={setUploadedDamageFiles}
                    uploadedDamageFiles={uploadedDamageFiles}
                  />
                )}
                {activeStep === 7 && (
                  <Step8
                    register={register}
                    errors={errors}
                    setSignaturePad={setSignaturePad}
                    signaturePad={signaturePad}
                  />
                )}
      
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={6}>
                    <Button
                      type="button"
                      variant="outlined"
                      color="secondary"
                      fullWidth
                      disabled={activeStep === 0 && !isAdmin}
                      onClick={prevStep}
                    >
                      Anterior
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    {activeStep < steps.length - 1 ? (
                      <div>
                        <Button
                          type="button"
                          variant="contained"
                          color="primary"
                          fullWidth
                          onClick={handleSubmit(handleNext)}
                        >
                          Siguiente
                        </Button>
                      </div>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={isLoading}
                      >
                        {isLoading ? "Enviando..." : "Enviar"}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Paper>
      
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={openAlert}
              autoHideDuration={6000}
              onClose={handleClose}
              message="Formulario enviado con éxito"
            />
      
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={openAlertError}
              autoHideDuration={6000}
              onClose={handleClose}
              message="Error al enviar el formulario"
            />
            <div style={{textAlign: "center", marginTop: "10px"}}>
              <img src={logo} alt="Logo CodeCanario" width={120}/>
            </div>
          </Container>
        )}
      </>
    );
  
};

export default StepsPage;
